import { createContext } from 'react'

import { noopAsync } from '@app/utils/noop'

import type { MountContextInterface } from './types'

export const MountContext = createContext<MountContextInterface>({
  push: () => noopAsync,
  pop: noopAsync,
  autoclose: noopAsync,
  isMounted: () => false,
})
